import { customLocale, getDateTimeFormatConverter } from './formatters';

export function getPreviousDate(date) {

	const d = new Date(date);
	d.setDate(d.getDate() - 1);

	return customLocale.format('%Y-%m-%d')(d);

}

export function getNextDate(date) {

	const d = new Date(date);
	d.setDate(d.getDate() + 1);

	return customLocale.format('%Y-%m-%d')(d);

}

export function getMonthNames() {
	return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
}

export function isDateInRange(time, minDate, maxDate) {
	const minTime = minDate != null
		? Number(getDateTimeFormatConverter('%Y-%m-%d %H:%M:%S', '%Q')(minDate + ' 00:00:00'))
		: Number.NEGATIVE_INFINITY;

	const maxTime = maxDate != null
		? Number(getDateTimeFormatConverter('%Y-%m-%d %H:%M:%S', '%Q')(maxDate + ' 00:00:00'))
		: Number.POSITIVE_INFINITY;

	return time >= minTime && time <= maxTime;
}



// WEBPACK FOOTER //
// ./utils/date-utils.js